import { Codename } from '@/api/types/workstation'
import { getAdditionalWorkstationMonthlyPrice } from '@/services/bundles'
import { getDaysRoudedUpBetweenTimestamps } from '@/services/date'
import { BundlePreset } from '@/store/types/config'

export function priceForAdditionalWorkstation(
  bundles: BundlePreset[],
  codename: Codename,
  nextBillingPeriodTimestamp: number,
): string {
  const fullPrice = parseFloat(getAdditionalWorkstationMonthlyPrice(bundles, codename))
  const days = getDaysRoudedUpBetweenTimestamps(nextBillingPeriodTimestamp, Date.now())
  // this should be probably fixed to reflect something less generic
  const AVERAGE_MONTH_DAYS = 30.5
  const fractionPriceInCents = Math.ceil((fullPrice * days * 100) / AVERAGE_MONTH_DAYS)

  return formatPriceFromCents(fractionPriceInCents)
}

/**
 * Format price
 * @param cents number of cents
 * @returns a neatly-formatted price string
 */
export const formatPriceFromCents = (cents: number = 0): string => {
  const roundedCents = Math.round(cents)
  if (!roundedCents) return '0.00'
  const dollars = Math.floor(roundedCents / 100)
  const centRest = roundedCents % 100
  const remainingCents = String(centRest).padStart(2, '0')
  return `${dollars}.${remainingCents}`
}

const getTaxAmmount = (netto: string, taxRate: string): string => {
  const perHourNumber = parseFloat(netto)
  const taxRateNumber = parseFloat(taxRate)
  if (!taxRateNumber) return (0).toFixed(2)
  return ((taxRateNumber / 100) * perHourNumber).toFixed(2)
}

/**
 * A Helper - take the original price and tax strings and calculate total
 * @param netto A price with no tax string
 * @param taxRate an applicable tax, a string
 * @returns a formatted string with total price
 */
export const getTotal = (netto: string, taxRate: string): string => {
  const taxAmmount = parseFloat(getTaxAmmount(netto, taxRate))
  if (!taxAmmount) return netto
  return (parseFloat(netto) + taxAmmount).toFixed(2)
}
